/**
 * @class
 */
var AitiProductImpression = function(element, productId, source, storeId, count) {

    count = count || 1;

    this.getKey = function() {
        return this.getProductId() + ';' + this.getSource() + ';' + this.getStoreId();
    };

    this.getElement = function() {
        return element;
    };

    this.getProductId = function() {
        return productId;
    };

    this.getSource = function() {
        return source;
    };

    this.setSource = function(_source) {
        source = _source;
        return this;
    };

    this.getStoreId = function() {
        return storeId;
    };

    this.getCount = function() {
        return count;
    };

    this.setCount = function(_count) {
        count = _count;
        return this;
    };

    this.toJSON = function() {
        return {
            productId: this.getProductId(),
            source: this.getSource(),
            storeId: this.getStoreId(),
            count: this.getCount()
        };
    };
}

export default AitiProductImpression;
